import React from 'react';
 
const SecondaryLoadingScreen = () => {
  return (
    <div className="flex items-center justify-center absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 z-50">
      <div className="flex flex-col items-center">
        <div
          className="w-12 h-12 border-4 border-solid rounded-full animate-spin"
          style={{ borderColor: '#DC0A0A', borderTopColor: 'transparent' }}
        />
      </div>
    </div>
  );
};
 
export default SecondaryLoadingScreen;